import { h } from "preact";

// The one loader of the app: a green ring on the palette's grey track, with
// an optional line of text under it. Every place that waits on the network
// renders this, so the wait looks the same everywhere.
const ProcessingComponent = ({ height, msg }) => (
  <div
    className="ob-loader"
    role="status"
    aria-live="polite"
    style={height ? { minHeight: height } : undefined}
  >
    <span className="ob-loader__ring" aria-hidden="true" />
    {msg && <p className="ob-loader__msg">{msg}</p>}
  </div>
);

export default ProcessingComponent;
